import React from 'react';
import styled from 'styled-components';
import { paperWhite } from 'core/styles';
import { TextStyle } from 'components/Text';

export const StyledContainer = styled.div`
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 35%;
`;

const TopSquare = styled.div`
  background-color: ${paperWhite};
  width: 40%;
  min-height: 2rem;
`;

export const Container = ({ children }) => (
  <StyledContainer>
    <TopSquare />
    {children}
  </StyledContainer>
);

export const Wrapper = styled.div`
  text-align: center;
  background-color: ${paperWhite};
  width: 70%;
  padding: 1vh 2rem;
  min-height: 25vh;
`;

export const WrapperGraveyard = styled.div`
  box-sizing: border-box;
  position: fixed;
  top: 43vw;
  text-align: center;
  width: 100%;
`;

export const ZoomedWrapper = styled.div`
  box-sizing: border-box;
  position: fixed;
  top: 40vw;
  left: 19vw;
  width: 60.5vw;
  height: 36vh;
  text-align: center;
  padding: 2vw 4vw;
  & ${TextStyle} {
    margin-top: 1.2vw;
    font-size 3vw;
  }
`;
